/**
 * Public Redwood Seed URL for the current environment.
 * dev  → https://seed.dev.redwoodvaluation.com
 * prod → https://seed.redwoodvaluation.com
 */
export function getRedwoodSeedUrl() {
  const envLabel = (process.env.REACT_APP_ENV_LABEL || '').trim().toLowerCase();
  if (envLabel && envLabel !== 'prod') {
    return `https://seed.${envLabel}.redwoodvaluation.com`;
  }
  return 'https://seed.redwoodvaluation.com';
}

/** Hostname only, for link display text (e.g. seed.dev.redwoodvaluation.com). */
export function getRedwoodSeedHostLabel() {
  try {
    return new URL(getRedwoodSeedUrl()).host;
  } catch {
    return 'seed.redwoodvaluation.com';
  }
}
